import React from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/tripSheets";
import connect from "./container";
import List from "./list";
import Show from "./show";

function TripSheets({ match, location, history, clearParams, ...rest }) {
    const back = () => history.push(match.path);

    React.useEffect(() => {
        return () => clearParams("trip-sheets");
    }, []);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={`${match.path}/new`}
                    render={(routeProps) => (
                        <Show
                            {...routeProps}
                            transition="full"
                            title="Новый путевой лист"
                            back={back}
                            source={source}
                            isNew
                        />
                    )}
                />
                <Route
                    exact
                    path={match.path}
                    render={() => (
                        <List
                            {...rest}
                            match={match}
                            location={location}
                            history={history}
                            isTable
                            transition="full"
                            nofilter
                            title="Журнал путевых листов"
                            createBtnText="Создать путевой лист"
                            source={source}
                        />
                    )}
                />
                <Route
                    path={`${match.path}/:id`}
                    render={(routeProps) => (
                        <Show {...routeProps} transition="full" title="Путевой лист" back={back} source={source} />
                    )}
                />
            </Switch>
        </div>
    );
}

export default connect(TripSheets);
